import React from 'react';
import MediaQuery from 'react-responsive';
import styled from 'styled-components';
import { Subscribe } from 'unstated';
//
import AppState from 'state';
//
import Hamburger from './hamburger';
import Header from './header';
//
export default ({ onlyNav }) => (
  // Desktop
  <MediaQuery minWidth={769}>
    {matches => {
      if (matches) {
        // Default
        return (
          <Wrap>
            <Header on toggle={() => true} />
          </Wrap>
        );
      }

      // Mobile
      return (
        <Subscribe to={[AppState]}>
          {({ state }) => (
            <Wrap active={onlyNav || state.headerOpen} onlyNav={onlyNav}>
              {!onlyNav && <Hamburger />}
              {(onlyNav || state.headerOpen) && (
                <Header onlyNav={onlyNav} on={onlyNav || state.headerOpen} />
              )}
            </Wrap>
          )}
        </Subscribe>
      );
    }}
  </MediaQuery>
);
//
const Wrap = styled.div`
  background-color: ${({ active }) => (active ? '#fff' : 'transparent')};
  height: ${({ active }) => (active ? '100vh' : '37px')};
  left: 0;
  overflow: scroll;
  padding: ${({ onlyNav }) =>
    onlyNav ? '0 1.5vw 2rem 2vw' : '1rem 1.5vw 2rem 2vw'};
  position: fixed;
  top: 0;
  width: ${({ active }) => (active ? '100%' : '32px')};
  z-index: 1000;

  @media (min-width: 768px) {
    background-color: #fff;
    height: 100vh;
    left: 1vw;
    padding: 0;
    width: 200px;
  }
`;
